import { FC, useRef, useState, useEffect, useMemo } from 'react'

import { ITestImageMatching } from 'shared/types'
import {
  VStack,
  Box,
  AspectRatio,
  Image,
  GridItem,
  HStack,
  Text
} from '@chakra-ui/react'
import get from 'lodash/get'
import last from 'lodash/last'
import Attempts from 'shared/components/sections/sectionTestLinkByMeaning/Attempts'
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter'

type Props = {
  m: ITestImageMatching
  onDragEndResult: (
    value: string,
    droppedValue: string,
    isCorrect: boolean
  ) => void
  droppedValue?: string
  droppedWord?: string
  isComplete: boolean
}

const MatchingImageExamination: FC<Props> = ({
  m,
  onDragEndResult,
  isComplete,
  droppedValue,
  droppedWord
}) => {
  const ref = useRef(null)
  const [isDraggedOver, setIsDraggedOver] = useState(false)

  useEffect(() => {
    const el = ref.current

    return dropTargetForElements({
      element: el,
      onDragEnter: () => setIsDraggedOver(true),
      onDragLeave: () => setIsDraggedOver(false),
      getData: () => ({ matchId: m.id }),
      onDrop: (args) => {
        console.log('ON DROP:', args)
        const droppedValue = get(args.source.data, 'matchId') as string
        const isCorrect = m.id === droppedValue
        onDragEndResult(m.id, droppedValue, isCorrect)
        setIsDraggedOver(false)
      },
      canDrop: ({ source }) => {
        return !isComplete
      }
    })
  }, [m.id, isComplete])

  const { bg, color, borderColor } = useMemo(() => {
    const isCorrect = droppedValue === m.id
    if (isComplete && isCorrect) {
      return {
        bg: 'green.50',
        borderColor: 'green.800',
        color: 'green.800'
      }
    } else if (isComplete && !isCorrect) {
      return {
        bg: 'red.50',
        borderColor: 'red.700',
        color: 'red.700'
      }
    } else if (droppedValue) {
      return {
        bg: 'transparent',
        borderColor: 'wood.700',
        color: 'wood.700'
      }
    } else {
      return {
        bg: 'black.100',
        borderColor: 'black.100',
        color: 'white'
      }
    }
  }, [isComplete, droppedValue, m.id])

  return (
    <GridItem ref={ref}>
      <VStack>
        <Box
          w='full'
          // maxW={'246px'}
          h='full'
          // maxH={'246px'}
          // borderWidth={1}
          // borderColor={'wood.100'}
          // rounded={'sm'}
        >
          <AspectRatio ratio={1} maxW={'full'} w='full'>
            <Box position='relative'>
              <Image fit='cover' src={m.imageUrl} rounded={'xs'} />
              <Box
                position='absolute'
                top={0}
                left={0}
                right={0}
                bottom={0}
                bg='black'
                opacity={!isComplete && isDraggedOver ? 0.5 : 0}
                rounded={'xs'}
              />
            </Box>
          </AspectRatio>
        </Box>
        <HStack
          w='full'
          justify='flex-start'
          spacing={1}
          mx={1}
          // position={'relative'}
        >
          <HStack
            // minW={isComplete ? 0 : 16}
            w='full'
            px={2}
            h={8}
            bg={!isComplete && isDraggedOver ? 'white' : bg}
            rounded={'4px'}
            borderWidth={1}
            borderColor={borderColor}
            color={color}
            // position={'absolute'}
          >
            <Box>
              {/* {isComplete && ( */}
              <Text whiteSpace={'nowrap'} cursor={'default'}>
                {droppedWord}
              </Text>
              {/* )} */}
            </Box>
          </HStack>
        </HStack>
      </VStack>
    </GridItem>
  )
}

export default MatchingImageExamination
